import { Outlet } from "react-router-dom";
import InfoNavbar from "../components/informational/InfoNavbar";
import InfoFooter from "../components/informational/InfoFooter";

/** Public shell for the /info/* marketing guides */
export default function InformationLayout() {
  return (
    <div className="flex min-h-dvh flex-col bg-white">
      <InfoNavbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <InfoFooter />
    </div>
  );
}
